import React, { Component } from 'react'
import PropTypes from 'prop-types'

import classnames from 'classnames'
import { RIEInput } from 'riek'
import { DragDropContext } from 'react-beautiful-dnd'

import { validateSearchResults } from '../../functions'

import Member from './member'

class Members extends Component {
  constructor(props) {
    super(props)

    this.state = {
      artist: this.props.artist,
      isDragging: false,
      sourceDroppableId: undefined
    }
  }

  componentWillMount() {
    const { artist } = this.props

    this.setState({artist})
  }

  componentWillReceiveProps(nextProps) {
    const { artist } = nextProps

    if (artist !== this.props.artist) this.setState({artist})
  }

  // addMemberItem({memberId, itemId, itemPosition}, members, items) {
  //   const { sourceDroppableId } = this.state
  //   const memberItemIds = []
  //
  //   if (memberId && memberId !== sourceDroppableId && itemId) {
  //     const memberIndex = members.map(function(member) { return member.id }).indexOf(memberId)
  //     const memberItems = members[memberIndex].items
  //     const memberItemIndex = memberItems.map(function(item) { return item.id }).indexOf(itemId)
  //
  //     if (memberItemIndex === -1) {
  //       const itemIndex = items.map(function(item) { return item.id }).indexOf(itemId)
  //
  //       members = update(members, {
  //         [memberIndex]: {
  //           items: {$splice: [[itemPosition, 0, items[itemIndex]]]}
  //         }
  //       })
  //     }
  //
  //     members[memberIndex].items.map(item => memberItemIds.push(item.id))
  //
  //     this.props.editRiderMember({id: memberId, items: memberItemIds})
  //
  //     const memberExists = members.map(function(member) { return member.id }).indexOf(sourceDroppableId)
  //     if (memberExists !== -1) this.removeMemberItem({memberId: sourceDroppableId, itemId}, members, items)
  //   }
  // }

  // removeMemberItem({memberId, itemId}, members, items) {
  //   let memberItemIds = []
  //
  //   const memberIndex = members.map(function(member) { return member.id }).indexOf(memberId)
  //   const memberItems = members[memberIndex].items
  //   const memberItemIndex = memberItems.map(function(item) { return item.id }).indexOf(itemId)
  //
  //   if (memberItemIndex !== -1) {
  //     const itemIndex = items.map(function(item) { return item.id }).indexOf(itemId)
  //
  //     members = update(members, {
  //       [memberIndex]: {
  //         items: {$splice: [[items[itemIndex], 1]]}
  //       }
  //     })
  //   }
  //
  //   members[memberIndex].items.map(item => memberItemIds.push(item.id))
  //
  //   this.props.editRiderMember({id: memberId, items: memberItemIds})
  // }

  render() {
    const { view, members, availableItems, stageElements } = this.props
    const { artist, isDragging } = this.state

    const artistClassName = classnames({
      'riek': true,
      'artist': true,
      'h3': true,
      'placeholder': !artist
    })

    return (
      <section className="members">
        {
          view.editable
          ? <RIEInput
              value={artist || `Who's performing?`}
              propName="artist"
              className={artistClassName}
              classEditing="riek-editing"
              change={({artist}) => this.setState({artist}, () => this.props.editRider({artist}))} />
          : <div className={artistClassName}>{artist}</div>
        }

        <DragDropContext
          onDragStart={(start, provided) => this.setState({
            isDragging: true,
            sourceDroppableId: start.source.droppableId
          })}
          onDragEnd={(result, provided) => {
            this.setState({isDragging: false})
            // this.addMemberItem({memberId: result && result.destination ? result.destination.droppableId : null, itemId: result.draggableId, itemPosition: result.destination.index}, members, items)
          }} >
          <div>
            {/*<MembersItems items={availableItems} />*/}

            <ol className="cards">
              {
                members.map((member, index) => {
                  return (
                    <Member key={index}
                      view={view}
                      member={member}
                      position={index+1}
                      isDragging={isDragging}
                      createRiderItem={this.props.createRiderItem}
                      removeRiderMember={this.props.removeRiderMember}
                      createRiderMember={this.props.createRiderMember}
                      editRiderMember={this.props.editRiderMember}
                      moveRiderMember={this.props.moveRiderMember}
                      deleteRiderMember={this.props.deleteRiderMember}
                      availableItems={availableItems}
                      stageElements={stageElements}
                      searchResults={validateSearchResults(stageElements)}
                      getSearchResults={this.props.getSearchResults}
                      setAlert={this.props.setAlert} />
                  )
                })
              }

              {
                view.editable
                ? <li className="card card--add" onClick={() => {
                    this.props.addRiderMember({
                      id: undefined,
                      name: null,
                      email: null,
                      phone: null,
                      items: []
                    })
                  }}>
                    <div className="card-content" data-number={members.length+1}>
                      <h1 className="add-member">+</h1>

                      <p>Add new band member</p>
                    </div>
                  </li>
                : null
              }
            </ol>
          </div>
        </DragDropContext>
      </section>
    )
  }
}

Members.propTypes = {
  view: PropTypes.object,
  artist: PropTypes.string,
  members: PropTypes.array,
  items: PropTypes.array,
  availableItems: PropTypes.array,
  editRider: PropTypes.func,
  createRiderItem: PropTypes.func,
  addRiderMember: PropTypes.func,
  removeRiderMember: PropTypes.func,
  createRiderMember: PropTypes.func,
  editRiderMember: PropTypes.func,
  moveRiderMember: PropTypes.func,
  deleteRiderMember: PropTypes.func,
  stageElements: PropTypes.object,
  getSearchResults: PropTypes.func,
  setAlert: PropTypes.func
}

Members.defaultProps = {
  view: {},
  artist: null,
  members: [],
  items: [],
  availableItems: [],
  editRider: function() {},
  createRiderItem: function() {},
  addRiderMember: function() {},
  removeRiderMember: function() {},
  createRiderMember: function() {},
  editRiderMember: function() {},
  moveRiderMember: function() {},
  deleteRiderMember: function() {},
  stageElements: {},
  getSearchResults: function() {},
  setAlert: function() {}
}

export default Members



// WEBPACK FOOTER //
// ./src/components/rider/rider-members/members.js